import axios from 'axios';

export default {
  getStoreIdxChapter (idx) { // 챕터 리스트 (커리큘럼) 조회
    return new Promise((resolve, reject) => {
      axios.get(`/v3/store/${idx}/chapter`).then(response => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  getStoreIdxChapterLectureIdx (storeIdx, lectureIdx) { // 강좌 하나 상세 조회
    return new Promise((resolve, reject) => {
      axios.get(`/v3/store/${storeIdx}/chapter/lecture/${lectureIdx}`).then(response => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  postStoreIdxChapterLectureIdxSigned (storeIdx, lectureIdx, loginAt) {
    return new Promise((resolve, reject) => {
      axios.post(`/v3/store/${storeIdx}/chapter/lecture/${lectureIdx}/signed`, {
        login_at: loginAt
      }).then(response => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  postStoreIdxChapterLectureIdxPlaytime (storeIdx, lectureIdx, userPlaytime, lastViewedTime) {
    return new Promise((resolve, reject) => {
      axios.post(`/v3/store/${storeIdx}/chapter/lecture/${lectureIdx}/playtime`, {
        user_playtime: userPlaytime,
        last_viewed_time: lastViewedTime
      }).then(response => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  }
}
